import React, { Component } from "react";
import { SendNotificationPopUp } from "./sendNotification";
import { isFunction, get } from "lodash";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { SendSmsEmailConext } from "./provider";

// loader
import { LoaderPage } from "../../component/Loader";

// helper
import { NOTIFICATION_MAPPER } from "../../constant";

// actions
import { getNotificationActiveInfoAction } from "../../actions/notificationToggle.action";

// reusable component
import { CustomDropDown } from "../reusableComponent";
import DisplayByPermission from "../../component/DisplayByPermission";
import { getLocalstorage } from "../../helper";

class SendBy extends Component {
  state = {
    toggleNotification: false,
    selectedDropDown: "",
    stakeHoldersData: null
  };

  static getDerivedStateFromProps(props, state) {
    const { notificationReducer } = props;
    if (
      get(notificationReducer, "notificationInfo.value") ===
      NOTIFICATION_MAPPER._DISABLE
    ) {
      return {
        toggleNotification: true
      };
    }
    return {
      toggleNotification: false
    };
  }

  onDropDownClick = value => {
    try {
      const { getStakeHolders, getNotificationActiveInfoAction } = this.props;
      this.setState(
        {
          selectedDropDown: value.title,
          isLoading: true,
          stakeHoldersData: null
        },
        async () => {
          const notificationInfoResponse = await getNotificationActiveInfoAction();
          const { data, status } = notificationInfoResponse || {};
          const { value } = data || {};
          if (status && value === NOTIFICATION_MAPPER._ENABLE) {
            const response = isFunction(getStakeHolders) && getStakeHolders();
            response
              .then(resp => {
                const data = get(resp, "data", {});
                this.setState({
                  stakeHoldersData: get(data, "data", null),
                  isLoading: false
                });
              })
              .catch(error => {
                this.setState({ isLoading: false });
              });
          }
        }
      );
    } catch (e) {
      this.setState({ isLoading: false });
      console.log("Error while fetching stake holder - ", e.message);
    }
  };

  onCloseModal = () => {
    this.setState({
      selectedDropDown: ""
    });
  };

  // clear form data on submit
  onSubmitClearData = index => {
    this.setState(prevState => {
      const newState = [...prevState.stakeHoldersData];
      newState[index] = {
        toMails: "",
        ccMails: "",
        subject: "",
        message: "",
        mobileNumbers: "",
        userNotificationType: {
          displayName: get(newState[index], "userNotificationType.displayName")
        },
        disabled: true
      };
      return {
        stakeHoldersData: newState
      };
    });
  };

  render() {
    const { onDropDownClick, onCloseModal, onSubmitClearData } = this;
    const {
      isLoading,
      selectedDropDown,
      stakeHoldersData,
      toggleNotification
    } = this.state;
    //
    const {
      meetingId,
      notificationCO = {},
      customNotificationType,
      dropDownList = [
        { key: "email", title: "Email" },
        { key: "sms", title: "SMS" }
      ],
      containerClass = "",
      style,
      permission,
      projectAwardedBy
    } = this.props;
    const groupCategory = getLocalstorage("groupCategory");
    return (
      <SendSmsEmailConext.Provider
        value={{
          onCloseModal,
          stakeHoldersData,
          notificationCO,
          customNotificationType,
          onSubmitClearData,
          type: selectedDropDown
        }}
      >
        <LoaderPage loading={isLoading} />
        <DisplayByPermission display={!get(permission, "canViewOnlyProject")}>
          <div className={containerClass}>
            <div className="send_drop__down">
              {/* <CustomDropDown
                selected={{ key: "", title: "Compose" }}
                options={dropDownList}
                disabled={toggleNotification}
                onSelect={onDropDownClick}
                style={style}
              /> */}
              {/* {groupCategory !== "STATE_PMG" || projectAwardedBy === "STATE" ? ( */}
              <CustomDropDown
                selected={{ key: "", title: "Compose" }}
                options={dropDownList}
                disabled={toggleNotification}
                onSelect={onDropDownClick}
                style={style}
              />
              {/* ) : null} */}
              <section className="notification-modal">
                {stakeHoldersData && selectedDropDown === "Email" ? (
                  <SendNotificationPopUp meetingId={meetingId} />
                ) : null}
                {stakeHoldersData && selectedDropDown === "SMS" ? (
                  <SendNotificationPopUp meetingId={meetingId} />
                ) : null}
              </section>
            </div>
          </div>
        </DisplayByPermission>
      </SendSmsEmailConext.Provider>
    );
  }
}

function mapStateToProps(state) {
  return {
    notificationReducer: state.notificationReducer
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getNotificationActiveInfoAction
    },
    dispatch
  );
}

const SendByComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(SendBy);
export { SendByComponent };
